import { render, staticRenderFns } from "./investor-faqs.vue?vue&type=template&id=8571bbd8&scoped=true"
import script from "./investor-faqs.vue?vue&type=script&lang=js"
export * from "./investor-faqs.vue?vue&type=script&lang=js"
import style0 from "./investor-faqs.vue?vue&type=style&index=0&id=8571bbd8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8571bbd8",
  null
  
)

/* custom blocks */
import block0 from "./investor-faqs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,InpageNav: require('/vercel/path0/components/blocks/InpageNav.vue').default,FaqsAccordionMulti: require('/vercel/path0/components/datablocks/FaqsAccordionMulti.vue').default,FaqsAccordion: require('/vercel/path0/components/datablocks/FaqsAccordion.vue').default})
